import { env } from '@repo/env';
export const LOGIN_PATH = '/api/nts/v1/login';

type SegmentTrackingAttributesType = {
  anonymousUserId: string;
  deployableName: string;
  deployableVersion: string;
  driverContentId: string;
  driverContentSource: string;
  driverElement: string;
  driverFlowName?: string;
  driverLocation: string;
  driverPageName: string;
  driverPageUrl: string;
  driverPageViewId: string;
  driverSubLocation: string;
  mostRecentTraditionalDeviceId?: string;
};

export type Options = {
  redirectTo: string;
  cancelUrl?: string;
  initialScreen?: 'signin' | 'signup';
  loginHint?: string; // hint for the user who is trying to authenticate (such as email).
} & SegmentTrackingAttributesType;

export class Auth0 {
  private origin: string;

  constructor(origin: string) {
    this.origin = origin;
  }

  public generateAuthLink(options: Options) {
    const loginURL = new URL(LOGIN_PATH, this.origin);

    Object.entries(options).forEach(([key, value]) => {
      // it gets added separately due to the fallback
      if (key === 'redirectTo') {
        return;
      }
      loginURL.searchParams.append(key, value);
    });

    const redirectTo = options.redirectTo ?? (typeof window !== 'undefined' ? window.location.href : '');
    loginURL.searchParams.append('redirectTo', redirectTo);
    return loginURL.toString();
  }

  signIn(options: Omit<Options, 'initialScreen'>) {
    window.location.assign(this.generateAuthLink({ initialScreen: 'signin', ...options }));
  }

  signUp(options: Omit<Options, 'initialScreen'>) {
    window.location.assign(this.generateAuthLink({ initialScreen: 'signup', ...options }));
  }
}

export const auth0 = new Auth0(
  env.NEXT_PUBLIC_DEPLOYABLE_ENV === 'prod'
    ? 'https://www.nerdwallet.com/'
    : 'https://stage.nerdwallet.biz/',
);
